import ally from 'ally';

class Menu {


    constructor(element, options) {

        this.openSelector = options.openSelector;
        this.enableButtons = this.enableButtons;

        //nav element may be dynamically removed and added again, 
        //observer will reinitiate with new nav element by passing 
        //it to this.init(element)
        this.init(element);

        //start observers
        this.watch();
    }

    init(element) {
        this.element = element;
        this.document = this.element.ownerDocument;
        this.bodyWidth = this.document.body.getBoundingClientRect().width;
        this.app = this.document.getElementById("app");
        this.openMenuElements = this.getOpenMenuElements();
    }

    watch() {

        let self = this;
        
        //----- create observers

        //observes change in nav class attribute as nav open/close
        this.classObserver = new MutationObserver(this.classMutationCallback.bind(self));
        //observes resizing of page
        this.resizeObserver = new window.ResizeObserver(this.resizeMutationCallback.bind(self));
        //observes nav being added/removed from page, enabling/disabling classObserver and resizeObserver
        this.navObserver = new MutationObserver(this.navAddRemoveCallback.bind(self));

        //------ start watching
        
        //begin observing add/remove of nav to page
        this.navObserver.observe(this.app, { subtree: false, childList: true });

        //nav will have already been rendered before observer started, so check if nav exists, and if so 
        //start observing class change on nav and resize on page events
        if (this.document.querySelector("#main-nav")) {
            this.observeNavToggleState(true);
        }

    }

    /**
     * Check if buttons should be disabled
     * If the page is less than 1200px in width, page is in mobile mode, 
     * and if the menu is not collapsed, buttons in main content areas 
     * should be disabled
     * @returns boolean
     */
    calcButtonsDisabled() {
        let isDisabled = (this.bodyWidth < 1200 && !this.isMenuCollapsed() );
        return isDisabled;
    }

    /**
     * Test if nav contains class 'menu-collapsed
     * @returns boolean
     */
    isMenuCollapsed() {
        return this.element.classList.contains("menu-collapsed");
    }

    /**
     * Toggle observation on nav class attribute and page resize events
     * @param {boolean} enabled 
     */
    observeNavToggleState(enabled) {

        if (enabled) {
            this.classObserver.observe(this.element, { attributes: true });
            this.resizeObserver.observe(this.app);
        } else {
            this.classObserver.disconnect();
            this.resizeObserver.disconnect();
        }
    }

    /**
     * Callback on class attribute change on Nav. Will toggle button state depending on 
     * if the nav is determined to be opened or close.
     * @param {*} mutationsList 
     */
    classMutationCallback(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                var collapsed = this.isMenuCollapsed();
                this.toggleButtons(collapsed);
                this.toggleAriaHideMainContent(!collapsed);
            }
        }
    }

    /**
     * Callback on document body resize event, will update the determined bodyWidth, and 
     * execute a refresh on Button state.
     * @param {*} entries 
     */
    resizeMutationCallback(entries) {
        this.bodyWidth = entries[0].contentRect.width;
        this.refreshButtonState();
    }

    /**
     * Callback on add/remove node as direct child to app div. For each node 
     * added or removed, will execute the appropriate callback
     * @param {*} mutationsList 
     */
    navAddRemoveCallback(mutationsList) {
        let self = this;
        mutationsList.forEach(function (mutation) {
            mutation.removedNodes.forEach(self.onRemoveNav.bind(self));
            mutation.addedNodes.forEach(self.onAddNav.bind(self));
        });
    } 

    /**
     * On remove child node of app, determine if nav and stop observing 
     * class and resize mutations
     * @param {*} node 
     */
    onRemoveNav(node) {
        if(node.id == 'main-nav') {
            this.observeNavToggleState(false);
        }
    }

    /**
     * On add child node of app, determine if nav, and reinitatilise 
     * variables with new element and begin observing class and 
     * resize mutations
     * @param {*} node 
     */
    onAddNav(node) {
        if(node.id == 'main-nav') {
            this.init(node);
            this.observeNavToggleState(true);
        }
    }

    /**
     * Toggle buttons enabled/disabled depending on 
     * determined nav state.
     */
    refreshButtonState() {

        var collapsed = !this.calcButtonsDisabled();
        this.toggleButtons(collapsed);
        this.toggleAriaHideMainContent(!collapsed);
    }

    /**
     * Enable/Disable buttons depending on provided boolean value
     * @param {boolean} enabled 
     */
    toggleButtons(enabled) {
        if(enabled) {
            this.enableButtons();
        } else {
            this.disableButtons();
        }
    }


    enableButtons() {
        if (this.handle) {
            this.handle.disengage();
            this.handle = null;
        }

        
    }

    toggleAriaHideMainContent(hide) {
        this.document.querySelector("main")
            .setAttribute("aria-hidden", hide);
    }

    disableButtons() {
        if (!this.handle) {
            this.handle = ally.maintain.disabled({
                context: this.document.body,
                filter: [
                    this.element, 
                    this.document.querySelector("header")
                ] .concat(this.openMenuElements)
            });
        }
    }


    getOpenMenuElements() {
        return this.findAsArray(this.document, this.openSelector);
    }

    findAsArray(ele, selector) {
        var col = ele.querySelectorAll(selector);
        return Array.prototype.slice.call(col);
    }

}


Menu.DEFAULTS = {
    openSelector: ".menu-open"
};

export default Menu;


// WEBPACK FOOTER //
// ./project/client/src/core/components/menu/menu.js